<template>
  <div id="sds-submission-list" class="content content--borderless">
    <div class="content__breadcrumbs">
      <Breadcrumbs :items="breadcrumbs"></Breadcrumbs>
    </div>
    <div class="content__header">
      <div class="content__main-header">
        <div class="content__title">
          <div class="content__title__name">Usulan SDS &nbsp;<span class="text-primary">{{submissionPeriod}}</span>  </div>
          <div class="content__title__description">Baca panduan pemeriksaan terlebih dahulu sebelum melakukan pemeriksaan.</div>
        </div>
        <div class="ml-auto d-flex">
          <b-dropdown id="dropdown-dropup" text="Drop-Up" toggle-class="button px-2 button--sm button--outlined text-nowrap">
            <template #button-content>
                <VueFeather type="clock" size="14" stroke-width="2" style="display:nlock"></VueFeather> &nbsp; Periode: <span class="text-bold pl-1">{{submissionPeriod}}</span>
            </template>
            <b-dropdown-item  
              v-for="(period , index) in options.submissionPeriod" :key="index" 
              :active="submissionPeriod == period" 
              @click="
                resetFilter();
                submissionPeriod = period; 
                filterSdsItemList();
                getSubmissionSummaries()" 
            >
                {{period}}
            </b-dropdown-item>
          </b-dropdown>
          <b-button 
            type="button" class=" ml-2 button button--primary button--sm" 
            to="/old-sds/buat-usulan" 
            v-if="submissionPeriod == currentYear">
            <VueFeather type="plus" size="14" class="button__icon"></VueFeather>
            Tambah Usulan
          </b-button>
        </div>
      </div>
      <div class="tab-control" style="margin-left:-5px;margin-right:-5px">
        <div :class="tab.index == index ? 'tab-control__item tab-control__item--active':'tab-control__item'" 
          v-for="(item,index) in tab.items" :key="index" @click="tabChange(index)">
          <div class="tab-control__item__name">
            {{item.name}} ({{item.count}})
          </div>
        </div>
      </div>
    </div>
    <div class="content__body pb-5">
      <div class="table-search">
        <b-input-group>
          <b-input-group-prepend is-text class="bg-none">
            <VueFeather type="search" size="16" stroke-width="3" stroke="#919191" ></VueFeather>
          </b-input-group-prepend>
          <b-form-input 
            type="search"
            debounce="500"
            size="sm"
            v-model="formFilter.name" 
            placeholder="Cari nama usulan konsep, variabel dan indikator . . ." 
            class="border-left-0"></b-form-input>
        </b-input-group>
        <button type="button" class="button" variant="primary" size="sm" @click="showModalFilter">
          <VueFeather type="filter" size="14" class="button__icon"></VueFeather>
          filter <span class="button__count" v-if="filterCount>0">{{filterCount}}</span>
        </button>
      </div>
      <div class="table-filter" >
        <div class="tags" v-show="filterCount>0">
          <div class="tag" v-if="tagsFilter.submissionType">
            <div class="tag__field">Jenis Usulan</div>
            <div class="tag__value">{{options.submissionType.find(x=>x.value == tagsFilter.submissionType).text}}</div>
            <div class="tag__remove" v-on:click="()=>{
              formFilter.submissionType = null;
              filterSdsItemList()
              }"
            ><VueFeather type="x" size="12"></VueFeather></div>
          </div>
          <div class="tag tag--primary" v-if="tagsFilter.sdsType">
            <div class="tag__field">Jenis sds</div>
            <div class="tag__value">{{options.sdsType.find(x=>x.value == tagsFilter.sdsType).text}}</div>
            <div class="tag__remove" v-on:click="()=>{
              formFilter.sdsType = null;
              filterSdsItemList()
            }"><VueFeather type="x" size="12"></VueFeather></div>
          </div>

          <div class="tag tag--secondary" v-if="tagsFilter.subjectField">
            <div class="tag__field">Subyek</div>
            <div class="tag__value">{{getSubjectFieldLabel(tagsFilter.subjectField)}}</div>
            <div class="tag__remove" v-on:click="()=>{
              formFilter.subjectField = null;
              filterSdsItemList()
            }"><VueFeather type="x" size="12"></VueFeather></div>
          </div>

          <div class="tag tag--tertiary" v-if="tagsFilter.status">
            <div class="tag__field">Status</div>
            <div class="tag__value">{{options.status.find(x=>x.value == tagsFilter.status).label}}</div>
            <div class="tag__remove" v-on:click="()=>{
              formFilter.status = null;
              filterSdsItemList()
            }"><VueFeather type="x" size="12"></VueFeather></div>
          </div>
        
          <!-- <div class="tag tag--quaternary" v-if="tagsFilter.requester && tab.index!=1">
            <div class="tag__field">Pengusul</div>
            <div class="tag__value">{{options.requester.find(x=>x.id == tagsFilter.requester).label}}</div>
            <div class="tag__remove" v-on:click="()=>{
              formFilter.requester = null;
              filterSdsItemList();
            }">x</div>
          </div> -->
          <div class="tag tag--senary" v-if="tagsFilter.produsenData">
            <div class="tag__field">Produsen Data</div>
            <div class="tag__value">{{tagsFilter.produsenData.name}}</div>
            <div class="tag__remove" v-on:click="()=>{
              formFilter.produsenData = null;
              filterSdsItemList();
            }"><VueFeather type="x" size="12"></VueFeather></div>
          </div>
        </div>
      </div>
      <div class="table-wrapper" :style="filterCount==0? 'margin-top:15px':''">
        <b-table class="table--light" :items="table.items" :fields="table.fields" show-empty> 
          <template #cell(no)="data">
            {{ startRowNumber + data.index}}
          </template>
          <template #cell(submission_type)="data">
            {{ data.value == 'NEW' ? 'Baru':'Pemutakhiran'}} 
          </template>
          <template #cell(sds_type)="data">
            {{ data.value == 'CONCEPT' ? 'Konsep':(data.value == 'VARIABLE' ? 'Variabel':'Indikator')}}
          </template>
          <template #cell(requester)="data">
            <div>{{data.item.requester.name}}</div>
            <div class="text-10 text-600">
              {{data.item.requester.organization.name}} 
            </div>
          </template>
          <template #cell(created_at)="data">
            {{dateFormatter(data.value)}}
          </template>
          <template #cell(status)="data">
            <div :class="'status status--'+statusFormatterStyle(data.value)">
              {{statusFormatter(data.value)}}
            </div>
          </template>
          <template #cell(action)="data">
            <div class="d-flex justify-content-center">
              <b-link  
                class="button button--action button--action--view " v-b-tooltip.hover title="Lihat detail"
                :href="'/old-sds/lihat-detail-usulan/'+data.item.id"
              >
                <VueFeather type="eye" size="14"></VueFeather>
              </b-link>
              <b-link  class="button button--action button--action--edit " v-b-tooltip.hover :title="editable(data.item) ? 'Edit':'Anda tidak bisa mengedit usulan orang lain'"
                :href="'/old-sds/edit-usulan/'+data.item.id" :disabled="!editable(data.item)"
              >
                <VueFeather type="edit-3" size="14"></VueFeather>
              </b-link>
              <b-link  class="button button--action button--action--delete" v-b-tooltip.hover :title="deleteable(data.item) ? 'Hapus':'Anda tidak bisa menghapus usulan orang lain'"  
              v-on:click="()=>{deletedSdsItemId = data.item.id;$bvModal.show('modal-delete')}" :disabled="!deleteable(data.item)">
                <VueFeather type="x" size="14"></VueFeather>
              </b-link>
            </div>
          </template>
          <template #empty>
            <div class="table__empty">
              <div v-if="isLoading">
                <VueFeather type="loader" animation="spin" size="18"></VueFeather> &nbsp; Memuat data</div>
              <div v-else>
                <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;
                  Belum ada usulan yang diajukan
              </div>
            </div>
          </template> 
        </b-table>
        <b-pagination
          class="mt-3 "
          align="center"
          v-if="table.pagination.totalElements >0 && isLoading == false"
          v-model="table.pagination.currentPage"
          :total-rows="table.pagination.totalElements"
          :per-page="table.pagination.pageSize"
          @input="filterSdsItemList"
        ></b-pagination>
      </div>
    </div>
    <b-modal  hide-header hide-footer id="modal-delete" size="sm" content-class="modal--confirmation text-center" >
        <div class="p-3 text-danger" >
          <div >
            <VueFeather type="x-circle" size="60" stroke-width="2" stroke="#ff0055"></VueFeather>
          </div>
          <div class="text-center mt-2" style="font-size:16px;font-weight:600;color:#ff0055;">
            Apakah anda yakin menghapus item ini?
          </div>
          <div class="mt-1" style="color:#2e2e2e;font-weight:500;opacity:0.8;font-size:13px;letter-spacing:.2px">
            Ketika dihapus, item tidak bisa dikembalikan lagi, kecuali anda melakukan input ulang
          </div>
        </div>
        <div class="mt-3 mb-2">
          <b-button class="i-button mr-2" 
            v-on:click="()=>{$bvModal.hide('modal-delete');}"
          >Batal</b-button>
          <b-button class="i-button i-button-danger" 
            v-on:click="deleteSdsItem"
          >Hapus</b-button>
        </div>
      </b-modal>
    <b-modal hide-header hide-footer id="modal-filter" modal-class="modal-form" size="md">
        <div class="modal__header">
          <div class="modal__header__icon">
            <VueFeather type="search" size="16"></VueFeather>
          </div>
          <div class="modal__header__title">
            <div class="modal__header__title__name"> 
              Filter Usulan 
            </div>
            <div class="modal__header__title__description"> 
              Gunakan filter untuk mendapatkan hasil pencarian yang lebih baik
            </div>
          </div>
          <div class="modal__header__close">
            <button  class="button button--action" @click="$bvModal.hide('modal-filter')">
              <VueFeather type="x" size="14" stroke-width="1"></VueFeather>
            </button>
          </div>
        </div>
        <div class="modal__body">
          <div class="form">
            <b-form-group label="Subyek">
              <Treeselect 
                clearable
                placeholder="Pilih subyek"
                v-model="formFilter.subjectField"
                :disable-branch-nodes="true"
                :options="options.subjectField"
                :normalizer="subjectNormalizer"
                
              >
                <div slot="option-label" slot-scope="{node}" class="d-flex">
                  <div :style="node.raw.code.length==1 ? 'width:20px':(node.raw.code.length<=4 ? 'width:28px':'width:40px;margin-left:10px' )">{{node.raw.code}}.</div>
                  <div>{{node.raw.name}}</div>
                </div>
              </Treeselect>
            </b-form-group>
            

            
            
            <b-form-group label="Status" v-if="tab.index != 2">
              <Treeselect 
                clearable placeholder="Pilih status" 
                v-model="formFilter.status" 
                :options="role.isWalidataKabupatenKota([appData.current_role]) || role.isProdusenDataKabupatenKota([appData.current_role]) ? options.statusKabKota :  
                          role.isWalidataProvinsi([appData.current_role]) || role.isProdusenDataProvinsi([appData.current_role]) ? options.statusProvinsi : options.statusPusat" 
                :disable-branch-nodes="true"
              />
            </b-form-group>
            <!-- <b-form-group label="Pengusul">
              <Treeselect 
                clearable placeholder="Pilih nama pengusul" 
                v-model="formFilter.requester" :options="options.requester" 
              />
            </b-form-group> -->
            <b-form-group label="Produsen Data" v-if="role.isWalidata([appData.current_role])">
              <Treeselect 
                clearable
                valueFormat="object"
                placeholder="Nama Produsen Data"
                v-model="formFilter.produsenData"
                :async="true"
                :options="options.produsenData"
                :loadOptions="produsenDataLoadOptions"
                :normalizer="produsenDataNormalizer"
                searchPromptText="Ketikkan beberapa huruf terlebih dahulu untuk memulai pencarian... "
              />
            </b-form-group>

            <div style="margin:2px">
              <b-row>
                <b-col>
                  <b-form-group label="Jenis SDS">
                    <b-form-radio-group
                      v-model="formFilter.sdsType"
                      :options="options.sdsType"
                      stacked
                    ></b-form-radio-group>
                  </b-form-group>
                </b-col>
                <b-col >
                  <b-form-group label="Jenis Usulan">
                    <b-form-radio-group
                      v-model="formFilter.submissionType"
                      :options="options.submissionType" stacked
                    ></b-form-radio-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <b-button class="button button--outlined mr-2" @click="$bvModal.hide('modal-filter');">Batal</b-button>
            <b-button class="button button--primary" @click="()=>{$bvModal.hide('modal-filter');filterSdsItemList()}">Terapkan</b-button>
          </div>
        </div>
      </b-modal>
  </div>
</template>

<script>
import "@/assets/scss/indah.scss";
import "@/assets/scss/main.scss";
import "@/assets/scss/treeselect.scss";
import Breadcrumbs from "@/components/Breadcrumbs";
import * as role from '@/views/ms/SdiRole.js';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import moment from 'moment';
import VueFeather from 'vue-feather';
import SdsService from "../../../services/SdsService";
import store from "../../../store";
import SubjectField from '../data/subject_field.js';
export default{
  components:{
    Treeselect,
    VueFeather,
    Breadcrumbs
  },
  data() {
    return {
      isLoading:false,
      deletedSdsItemId:null,
      breadcrumbs: [
        {
          text: "Home",
          href: "/old-sds",
        },
        {
          text: "Daftar usulan",
          href:'',
          active: true,
        },
      ],
      tab:{
        index:0,
        items:[
          {
            name:'Semua',
            count : 0,
          },
          {
            name:'Usulan-ku',
            count : 0,
          },
          {
            name:'Usulan lain yang disetujui',
            count : 0,
          },
        ]
      },
      user:null,
      userRoles:[],
      produsenData:null,
      myOrganizationId:null,
      submissionSummaries:null,
      activeSubmissionPeriod:null,
      submissionPeriod:null,
      formFilter:{
        name:null,
        submissionType:null,
        sdsTypes:null,
        subjectField:null,
        status:null,
        requester:null,
        produsenData:null,
      },
      tagsFilter:{
        name:null,
        submissionType:null,
        sdsTypes:null,
        subjectField:null,
        status:null,
        requester:null,
        produsenData:null,
      },
      table:{
        items: [],
        fields:[
          {
            key:'no',
            class:'text-center w-51'
          },
          {
            key: 'submission_type',
            label: 'Jenis Usulan',
            class:'text-left text-nowrap w-101'
          },
          {
            key: 'sds_type',
            label: 'Jenis Sds',
            class:'text-left text-nowrap w-70'
          },
          {
            key:'name',
            label: 'Nama',
            class:'text-left'
          },
          {
            key:'requester',
            label: 'Nama Pengentri',
            class:'text-left w-170'
          },
          {
            key:'produsen_data_name',
            label: 'Produsen Data',
            class:'text-left w-170'
          },
          {
            key:'created_at',
            label: 'Tanggal Usulan',
            class:'text-left text-nowrap w-110'
          },
          {
            key:'status',
            class:'text-center text-nowrap'
          },
          {
            key:'action',
            label: 'Aksi',
            class:'text-center text-nowrap'
          },
        ],
        pagination:{
          currentPage:1,
          pageSize: 10,
          totalPages: null,
          totalElements:0,
        },
      },
      options:{
        submissionType:[
          {value:'NEW', text:'Baru'},
          {value:'UPDATE', text:'Pemutakhiran'},
        ],
        sdsType:[
          {value:'CONCEPT', text:'Konsep'},
          {value:'VARIABLE', text:'Variabel'},
          {value:'INDICATOR', text:'Indikator'},
        ],
        statusKabKota:[
          {id:'DRAFT_KABKOTA', label:'Draft'},
          {id:'SUBMITTED_KABKOTA', label:'Submit'},
          {id:'REVISED_KABKOTA', label:'Sudah diperbaiki'},
          {id:'REVIEW_KABKOTA', label:'Sedang diperiksa'},
          {id:'CORRECTION_KABKOTA', label:'Perlu perbaikan'},
          {id:'PENDING_KABKOTA', label:'Ditunda'},
          {id:'REJECTED_KABKOTA', label:'Ditolak'},
          {id:'APPROVED_KABKOTA', label:'Diterima'},
        ],
        statusProvinsi:[
          {id:'DRAFT_PROVINSI', label:'Draft '},
          {id:'SUBMITTED_PROVINSI', label:'Submit'},
          {id:'REVISED_PROVINSI', label:'Sudah diperbaiki'},
          {id:'REVIEW_PROVINSI', label:'Sedang diperiksa'},
          {id:'CORRECTION_PROVINSI', label:'Perlu perbaikan'},
          {id:'REJECTED_PROVINSI', label:'Ditolak'},
          {id:'APPROVED_PROVINSI', label:'Diterima'},
          {id:'PENDING_PROVINSI', label:'Ditunda'},
        ],
        statusPusat:[
          {id:'DRAFT_PUSAT', label:'Draft'},
          {id:'SUBMITTED_PUSAT', label:'Submit'},
          {id:'REVISED_PUSAT', label:'Sudah diperbaiki'},
          {id:'REVIEW_PUSAT', label:'Sedang diperiksa'},
          {id:'CORRECTION_PUSAT', label:'Perlu perbaikan'},
          {id:'REJECTED_PUSAT', label:'Ditolak'},
          {id:'APPROVED_PUSAT', label:'Diterima'},
          {id:'PENDING_PUSAT', label:'Ditunda'},
          {id:'PUBLISHED_PUSAT', label:'Publish'},
        ],
        statusTree:[
          {id: 'KabupatenKota', label:'Kabupaten/Kota',children:[
            {id:'DRAFT_KABKOTA', label:'Draft Produsen Data'},
            {id:'SUBMITTED_KABKOTA', label:'Submit Produsen Data'},
            {id:'REVISED_KABKOTA', label:'Sudah diperbaiki'},
            {id:'REVIEW_KABKOTA', label:'Diperiksa Walidata'},
            {id:'CORRECTION_KABKOTA', label:'Perbaikan Produsen Data'},
            {id:'PENDING_KABKOTA', label:'Ditunda Walidata'},
            {id:'REJECTED_KABKOTA', label:'Ditolak Walidata'},
            {id:'APPROVED_KABKOTA', label:'Diterima Walidata'},
          ]},
          {id: 'Provinsi', label:'Provinsi',children:[
            {id:'DRAFT_PROVINSI', label:'Draft Produsen Data '},
            {id:'SUBMITTED_PROVINSI', label:'Submit Produsen'},
            {id:'REVISED_PROVINSI', label:'Sudah diperbaiki'},
            {id:'REVIEW_PROVINSI', label:'Diperiksa Walidata Provinsi'},
            {id:'CORRECTION_PROVINSI', label:'Perbaikan Produsen Data & Walidata'},
            {id:'REJECTED_PROVINSI', label:'Ditolak Walidata'},
            {id:'APPROVED_PROVINSI', label:'Diterima Walidata'},
            {id:'PENDING_PROVINSI', label:'Ditunda Walidata'},
          ]},
          {id: 'Pusat', label:'Pusat',children:[
            {id:'DRAFT_PUSAT', label:'Draft Produsen Data'},
            {id:'SUBMITTED_PUSAT', label:'Submit Produsen Data'},
            {id:'REVISED_PUSAT', label:'Sudah diperbaiki'},
            {id:'REVIEW_PUSAT', label:'Diperiksa Walidata Pusat'},
            {id:'CORRECTION_PUSAT', label:'Perbaikan Produsen Data & Walidata'},
            {id:'REJECTED_PUSAT', label:'Ditolak Walidata'},
            {id:'APPROVED_PUSAT', label:'Diterima Walidata'},
            {id:'PENDING_PUSAT', label:'Ditunda Walidata'},
            {id:'PUBLISHED_PUSAT', label:'Publish'},
          ]},
        ],
        status:[
          {value:'DRAFT_KABKOTA', label:'Draft Produsen Data Kabupaten/Kota'},
          {value:'SUBMITTED_KABKOTA', label:'Submit Produsen Data Kabupaten/Kota'},
          {value:'REVISED_KABKOTA', label:'Sudah diperbaiki Produsen Data Kabupaten/Kota'},
          {value:'REVIEW_KABKOTA', label:'Diperiksa Walidata Kabupaten/Kota'},
          {value:'CORRECTION_KABKOTA', label:'Perlu Perbaikan Produsen Data & Walidata Kabupaten/Kota'},
          {value:'PENDING_KABKOTA', label:'Ditunda Walidata Kabupaten/Kota'},
          {value:'REJECTED_KABKOTA', label:'Ditolak Walidata Kabupaten/Kota'},
          {value:'APPROVED_KABKOTA', label:'Diterima Walidata Kabupaten/Kota'},

          {value:'DRAFT_PROVINSI', label:'Draft Produsen Data Provinsi'},
          {value:'SUBMITTED_PROVINSI', label:'Submit Produsen Data Provinsi'},
          {value:'REVISED_PROVINSI', label:'Sudah diperbaiki Produsen Data Provinsi'},
          {value:'REVIEW_PROVINSI', label:'Diperiksa Walidata Provinsi'},
          {value:'CORRECTION_PROVINSI', label:'Perbaikan Produsen Data & Walidata Provinsi'},
          {value:'REJECTED_PROVINSI', label:'Ditolak Walidata Provinsi'},
          {value:'APPROVED_PROVINSI', label:'Diterima Walidata Provinsi'},
          {value:'PENDING_PROVINSI', label:'Ditunda Walidata Provinsi'},

          {value:'DRAFT_PUSAT', label:'Draft Produsen Data Pusat'},
          {value:'SUBMITTED_PUSAT', label:'Submit Produsen Data Pusat'},
          {value:'REVISED_PUSAT', label:'Sudah diperbaiki Produsen Data Pusat'},
          {value:'REVIEW_PUSAT', label:'Diperiksa Walidata Pusat'},
          {value:'CORRECTION_PUSAT', label:'Perbaikan Produsen Data & Walidata Pusat'},
          {value:'REJECTED_PUSAT', label:'Ditolak Walidata Pusat'},
          {value:'APPROVED_PUSAT', label:'Diterima Walidata Pusat'},
          {value:'PENDING_PUSAT', label:'Ditunda Walidata Pusat'},
          {value:'PUBLISHED_PUSAT', label:'Publish'},
        ],
        subjectField : [],
        requester:[],
        organization:[],
        produsenData:null
      },
    }
  },
  watch:{
    'formFilter.name'(){
      this.filterSdsItemList();
    },
    'appData.current_role'(val, oldVal){
      if(val != oldVal && oldVal != null){
         this.filterSdsItemList();
         this.getSubmissionSummaries();
      }
    },
  },
  computed:{
    currentYear(){
      return new Date().getFullYear();
    },
    startRowNumber(){
      return this.table.pagination.totalElements == 0 ? '0' : (this.table.pagination.currentPage-1)*this.table.pagination.pageSize+1;
    },
    filterCount(){
      let count = 0;
      if(this.tagsFilter.status){count +=1}
      if(this.tagsFilter.submissionType){count +=1}
      if(this.tagsFilter.subjectField){count +=1}
      if(this.tagsFilter.sdsType){count +=1}
      if(this.tagsFilter.requester && this.tab.index!=1){count +=1}
      if(this.tagsFilter.produsenData && this.role.isSuperAdmin(this.userRoles)){count +=1}
      return count;
    },
    role(){
      return role;
    },
    isWalidataPusat(){
      return role.isWalidataPusat(this.userRoles);
    },
    isWalidataProvinsi(){
      return role.isWalidataPusat(this.userRoles);
    },
    isWalidataKabupatenKota(){
      return role.isWalidataPusat(this.userRoles);
    }

    
  },
  inject: ['appData'],
  async mounted(){
    this.getUserInfo(store.getters["auth/user"])
    this.setSubjectFieldsOptions();
    this.setInitialFilter();
    this.isLoading = true;
    this.setSubmissionPeriod();
    await this.getSubmissionSummaries();
    await this.filterSdsItemList();
  },
  methods:{
    setSubmissionPeriod(){
      let currentYear = new Date().getFullYear();
      this.submissionPeriod = currentYear;
      this.options.submissionPeriod = this.generateYearList(2021, currentYear).reverse();
    },
    generateYearList(start, stop, step = 1){
      return Array.from({ length: (stop - start) / step + 1}, (_, i) => start + (i * step));
    },
    setInitialFilter(){
      let submissionFilter = localStorage.getItem('sdsSubmissionFilter');
      if(submissionFilter !== null){
        let filter = JSON.parse(submissionFilter);
        if(filter.name){
          this.formFilter.name = filter.name
        }
        if(filter.status){
          this.formFilter.status = filter.status
        }
        if(filter.submissionType){
          this.formFilter.submissionType = filter.submissionType
        }
        if(filter.sdsType){
          this.formFilter.sdsType = filter.sdsType
        }
        if(filter.subjectField){
          this.formFilter.subjectField = filter.subjectField
        }
        if(filter.requester){
          this.formFilter.requester = filter.requester
        }
        if(filter.produsenData){
          this.formFilter.produsenData = filter.produsenData
        }
      }
    },    
    showModalFilter(){
      if(this.tagsFilter.sdsType == null){this.formFilter.sdsType = null}
      if(this.tagsFilter.submissionType == null){this.formFilter.submissionType = null}
      if(this.tagsFilter.subjectField == null){this.formFilter.subjectField = null}
      if(this.tagsFilter.status == null){this.formFilter.status = null}
      if(this.tagsFilter.requester == null){this.formFilter.requester = null}
      this.$bvModal.show('modal-filter')
    },
    resetFilter(){
      this.formFilter={
        name:null,
        submissionType:null,
        sdsTypes:null,
        subjectField:null,
        status:null,
        requester:null,
        produsenData:null,
      };
      this.tagsFilter={
        name:null,
        submissionType:null,
        sdsTypes:null,
        subjectField:null,
        status:null,
        requester:null,
        produsenData:null,
      };
    },
    
    async filterSdsItemList(){
      this.tagsFilter={
        name:null,
        submissionType:null,
        sdsTypes:null,
        subjectField:null,
        status:null,
        requester:null,
        produsenData:null
      };
      let name = this.formFilter.name;
      let submissionType = this.formFilter.submissionType;
      let sdsType = this.formFilter.sdsType;
      let subjectField = this.formFilter.subjectField;
      let status = this.formFilter.status;
      let requester = this.formFilter.requester;
      let produsenData = this.formFilter.produsenData;
      let page = this.table.pagination.currentPage-1;

      let query = "submissionPeriod="+this.submissionPeriod+"&page="+page+"&size=10";
      
      
      if(name){
        query += "&name="+name;
        this.tagsFilter.name = name;
      }
      if(submissionType){
        query += "&submissionType="+submissionType;
        this.tagsFilter.submissionType = submissionType;
      }
      if(sdsType){
        query += "&sdsType="+sdsType;
        this.tagsFilter.sdsType = sdsType;
      }
      if(subjectField){
        query += "&subjectFieldId="+subjectField;
        this.tagsFilter.subjectField = subjectField;
      }
      if(status){
        query += "&status="+status;
        this.tagsFilter.status = status;
      }
      if(requester){
        query += "&requestedBy="+requester;
        if(this.tab.index !=1){
          this.tagsFilter.requester = requester;
        }
      }

      if(this.tab.index==0){
        if(role.isProdusenData([this.appData.current_role])){
          query += "&produsenDataId="+this.user.organization.id;
        }else{
          //walidata, pembina data & superadmin
          if(produsenData){
            //filter produsen data only applicable for walidata, pembina data & superadmin
            query += "&produsenDataId="+produsenData.id;
            this.tagsFilter.produsenData = produsenData;
          }

          if(role.isWalidataPusat([this.appData.current_role])){
            query += "&walidataPusatId="+this.user.organization.id;
          }
          else if(role.isWalidataProvinsi([this.appData.current_role]) || role.isPembinaDataProvinsi([this.appData.current_role])){
            query += "&produsenDataProvinceCode="+this.user.organization.province.code;
          }
          else if(role.isWalidataKabupatenKota([this.appData.current_role]) || role.isPembinaDataKabupatenKota([this.appData.current_role])){
            query += "&produsenDataProvinceCode="+this.user.organization.province.code;
            query += "&produsenDataCityCode="+this.user.organization.city.code;
          }
        }
      }
      if(this.tab.index==2){
        query += "&status=APPROVED_PUSAT";
      }
      
      this.isLoading = true;
      this.table.items = [];
      await SdsService.getSdsItemListByQuery(query).then(
        (result)=>{
          let response = result.data;
          this.table.items = response.content;
          this.table.pagination.totalPages = response.total_pages;
          this.table.pagination.totalElements= response.total_elements;

          this.tab.items[this.tab.index].count = response.total_elements;
        },
        (error)=>{
          console.log(error)
        }
      )
      this.isLoading = false;

      localStorage.setItem('sdsSubmissionPeriod', this.submissionPeriod);
      localStorage.setItem('sdsSubmissionFilter', JSON.stringify(this.tagsFilter));
      
    },
     async getSubmissionSummaries(){
      await SdsService.getSubmissionSummaries(this.submissionPeriod,this.user.organization.id,this.user.username).then(
        (result)=>{
          this.submissionSummaries = result.data;
          this.tab.items[0].count = this.submissionSummaries.total_produsen_data_submission;
          this.tab.items[1].count = this.submissionSummaries.total_user_submission;
          this.tab.items[2].count = this.submissionSummaries.total_approved_submission;
        },
        (error)=>{
          console.log(error)
        }
      )
    }, 
    async deleteSdsItem(){
      await SdsService.deleteSdsItem(this.deletedSdsItemId).then(
        (result) => {
          this.$bvModal.hide('modal-delete');
          let response = result.data.result[0];
          if(response==null){
            this.filterSdsItemList();
          }
          else{
            if(response.status == 403){
              this.modal.error.title = 'Delete Item Gagal';
              this.modal.error.description = 'Anda hanya dapat menghapus item yang berstatus DRAFT saja';
            }
            else{
              this.modal.error.title = response.title;
              this.modal.error.description = response.detail;
            }
            this.$bvModal.show('modal-error');
          }
        },
        (error) => {
            console.log(error);
        }
      );
    },
    getUserInfo(user){
      this.user = {
        name : user.name,
        username: user.username,
        email: user.email,
        division: null,
        organization: {
          id: user.sdiOrganization.id,
          name: user.sdiOrganization.name,
          address: user.sdiOrganization.details.address,
          province: user.sdiOrganization.details.province,
          city: user.sdiOrganization.details.city,
        } 
      },
      this.myOrganizationId= this.user.organization.id;
      this.userRoles = user.role.slice(1,-1).split(", ");
    },
    
    //MODAL FUNCTION
    //UTILITIES FUNCTION
    loadOptions({callback}) {
      let result = 'Sedang melakukan load data'
      callback(null, result)
    },
    async produsenDataLoadOptions({searchQuery, callback}){
      let name = searchQuery;
      let page = 0;
      let provinceCode = null;
      let cityCode = null;

      if(this.isWalidataProvinsi){
        provinceCode = this.user.organization.province.code;
      }
      if(this.isWalidataKabupatenKota){
        provinceCode = this.user.organization.province.code;
        cityCode = this.user.organization.city.code;
      }
      await SdsService.getProdusenData(page, name, provinceCode, cityCode).then(
         (result)=>{
            let options = result.data.content;
            callback(null, options)
         },
         (error)=>{
            console.log(error)
         }
      );
    },
    normalizer(node) {
      return {
        id: node.value,
        label: node.label,
        children: node.children,
      }
    },
    organizationNormalizer(node) {
      return {
        id: node.id,
        label: node.instansi,
      }
    },
    produsenDataNormalizer(node) {
      return {
        id: node.id,
        label: node.name,
      }
    },
    subjectNormalizer(node) {
      return {
        id: node.id,
        label: node.name,
        children: node.children,
      }
    },
    capitalize([first, ...rest]){
      return first.toUpperCase() + rest.join('');

    },
    dateFormatter(stringDate){
      moment.locale("id");
      return moment(stringDate).format('LL');
    },
    statusFormatter(status){
      return status ? this.options.status.find(x=>x.value == status).label : 'Draft';
    },
    statusFormatterStyle(status){
      return status ? status.split('_')[0].toLowerCase() : 'draft';
    },
    setSubjectFieldsOptions(){
      let subjects =  [...SubjectField]
      
      let lv1 = subjects.filter(x=> x.level == 1);
      let lv2 = subjects.filter(x=> x.level == 2);
      let lv3 = subjects.filter(x=> x.level == 3);

      lv2 = lv2.map(item => {
        let lv2_children = lv3.filter(x => x.parent == item.id).map(({id,code,name})=>({id,code,name}));
        item = { id: item.id, code: item.code, name: item.name, parent: item.parent }
        return lv2_children.length>0 ? {...item, ...{children: lv2_children}} : item;
      })
      lv1 = lv1.map(item => {
        let lv1_children = lv2.filter(x => x.parent == item.id).map(x=> {delete x.parent; return x});
        return { id: item.id, code: item.code,  name: item.name,children: lv1_children }
      })
      this.options.subjectField = lv1;
    },
    getSubjectFieldLabel(id){
      return SubjectField.find(x=>x.id == id).name;
    },
    
    editable(sdsItem){
      if(this.role.isSuperAdmin(this.userRoles)){
        return true
      }else{
        if(['DRAFT_KABKOTA','DRAFT_PROVINSI','DRAFT_PUSAT','CORRECTION_KABKOTA','CORRECTION_PROVINSI','CORRECTION_PUSAT'].includes(sdsItem.status)){
          if(this.user.email == sdsItem.requester.email){
            return true;
          }else{
            if(this.user.organization.name == sdsItem.requester_organization || this.user.organization.id == sdsItem.requester_organization_id){
              return true
            }else if(this.user.organization.name == sdsItem.produsen_data_name || this.user.organization.id == sdsItem.produsen_data_id){
              return true
            }else{
              return false
            }
          }
        }
        else{
          return false
        }
      }
    },
    deleteable(sdsItem){
      if(sdsItem.status == 'DRAFT'){
        if(this.role.isSuperAdmin(this.userRoles)|| this.user.name == sdsItem.requester){
          return true;
        }else{
          if(this.user.organization.name == sdsItem.requester_organization){
            return true
          }else{
            return false
          }
        }
      }else{
        if(this.userRoles.includes('ROLE_SDS_ADMIN')){
          return true
        }else{
          return false
        }
      }
    },
    tabChange(index){
      this.tab.index = index;
      this.resetFilter();
      if(index==0){
        this.filterSdsItemList();
      }
      if(index==1){
        this.formFilter.requester = this.user.username;
        this.filterSdsItemList();
      }
      if(index==2){
        this.filterSdsItemList();
      }
      
    },
    
    
  }
}
</script>
